import { One, OrderDirection } from '@granlupo/api-client/generated/content/zeus'
import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import { serverPropsHandler } from '../libs/next/api/handlers'
import { IfHydrated } from '../libs/next/hydratation'
import { websiteContent } from '../libs/next/loaders/graphql/src/contentClient'
import { DogInfoForm } from '../src/components/dogForm/DogInfoForm'
import { Container } from '../src/components/shared/Container'
import { Layout } from '../src/components/shared/Layout'
import { InternalLink } from '../src/const/Links'
import { DogActivityFragment } from '../src/data/DogActivityFragment'
import { LayoutFragment } from '../src/data/LayoutFragment'
import { SeoFragment } from '../src/data/SeoFragment'
import style from '../src/styles/Wizard.module.sass'

type GenericPageProps = InferGetServerSidePropsType<typeof getServerSideProps>

export default function GenericPage(props: GenericPageProps) {
	return (
		<Layout
			hasBreadcrumbs
			footer={props.data.footer.getFooter}
			socials={props.data.socials.listSocial}
			seo={props.data.getWizardPage?.seo}
			url={InternalLink.Wizard}
		>
			<div className={style.container}>
				<Container size="narrow">
					<div className={style.content}>
						<IfHydrated
							yes={() => (
								<DogInfoForm dogActivities={props.data.listDogActivity} dogBodyTypes={props.data.listDogBodyType} />
							)}
						/>
					</div>
				</Container>
			</div>
		</Layout>
	)
}

// export const runtime = 'experimental-edge'
export const getServerSideProps = serverPropsHandler(async (context: GetServerSidePropsContext) => {
	context.res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate=3600')

	const content = websiteContent

	const data = await content('query')({
		...LayoutFragment(),
		listDogActivity: [{ orderBy: [{ dailyEnergyRequirementCoeficient: OrderDirection.asc }] }, DogActivityFragment()],
		listDogBodyType: [{}, { id: true, value: true }],
		getWizardPage: [{ by: { unique: One.One } }, { seo: [{}, SeoFragment()] }],
	})

	return {
		props: {
			data,
			initialQuery: context.query,
		},
	}
})
